import i18next from 'i18next';

import { FatalErrorWithCustomMessage } from '../Errors';

import { ErrorImageType } from '@egr/xbox/egr-gui-dialogs/Constants';

export class SessionExpiredError extends FatalErrorWithCustomMessage {
    public constructor(error: Error) {
        super(
            error,
            i18next.t('Session expired'),
            [],
            i18next.t('Your session has expired. The project must be closed.'),
            true,
            {
                errorImageType: ErrorImageType.SESSION_TIMEOUT
            },
        );

        Object.setPrototypeOf(this, SessionExpiredError.prototype);
    }
}